// extracted by mini-css-extract-plugin
module.exports = {"title":"member-header_title__TZSNd","links":"member-header_links__TrOQG","item":"member-header_item__PHcJ9"};